<template>
  <ui-dropper v-if="modelBlog?.is_editing" chevron-left>
    <template #head>
      <div class="space-x-4">
        <b>Blog</b>
        <span>Settings</span>
      </div>
    </template>
    <div class="shadow-inner shadow-gray-400 p-4 rounded">
      <blog-settings v-model="modelBlog" />
    </div>
  </ui-dropper>
</template>

<script setup lang="ts">
const modelBlog = defineModel<Blog>()
</script>
